import patient from '@/sui/data/sheets/edit/patient'
import tools from '@/sui/data/sheets/edit/tools'
import ice from '@/sui/tools/ice'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'
import clone from 'clone'

import {
  checkAge,
  checkDate,
  checkCompresses,
  checkGlovesPutOn,
  checkB2Gloves,
  checkDeviceInsertionSite,
  checkR1,
  checkProbeTouchedWithGloves,
  checkBMI
} from '@/sui/data/sheets/edit/notes/observa4'

import v2022 from '@/sui/data/sheets/edit/observa4/2022'

const result = clone(v2022)
result.rename(result.fields.isAdult, 'p1p2p3', 'p1p2p3r1')
result.rename(result.fields.childAge, 'p1p2p3', 'p1p2p3r1')
result.rename(result.fields.insertionSiteCleaned, 'p1p2p3p4', 'p1p2p3p4r1')
result.rename(result.fields.auditedCap, 'p1p3', 'p1p3r1')
result.rename(result.fields.compliantAuditedCap, 'p1p3', 'p1p3r1')
result.rename(result.fields.patientMask, 'p1p3b2', 'p1p3b2r1')
result.rename(result.fields.compliantPatientMask, 'p1p3b2', 'p1p3b2r1')
result.rename(result.fields.auditedMask, 'p1p3b2', 'p1p3b2r1')
result.rename(result.fields.compliantAuditedMask, 'p1p3b2', 'p1p3b2r1')
result.rename(result.fields.patientSterileField, 'p1', 'p1r1')
result.rename(result.fields.patientOtherSide, 'p3b2', 'p3b2r1')

//     UPDATE    obsManagment (list)    obsManagment>config>values: different sizes
result.fields.obsManagment.all.config.values = go.fields2025.obsManagment

// +++ ADD       r1type (list)
result.fields.catheterType.r1 = tools.cfg.list(
  `r1${fields.catheterType}`, result.fields.catheterType.p1.config.title,
  go.fields.r1Type, { sel: result.select.r1, srv: fields.catheterType }
)

// +++ ADD       r1otherCatheterType (text)
result.fields.otherCatheterType.r1 = tools.cfg.text(
  `r1${fields.otherCatheterType}`, result.fields.otherCatheterType.p1.config.title, {
    sel: tools.equals(result.fields.catheterType.r1.field, 6),
    srv: fields.otherCatheterType
  }
)

// +++ ADD       r1insertionSite (list)
// +++ ADD       p1insertionSite (list)
result.fields.insertionSite = (function () {
  const t = `Site d'insertion`
  const f = fields.insertionSite

  return {
    p1: tools.cfg.list(
      `p1${f}`, t, go.fields.p1Insertion, { sel: result.select.p1, srv: f }
    ),

    r1: tools.cfg.list(
      `r1${f}`, t, go.fields.reaInsertion, { sel: result.select.r1, srv: f }
    )
  }
})()

// +++ ADD       insertionSiteDetail (text)
result.fields.insertionSiteDetail = {
  p1r1: tools.cfg.text(
    fields.insertionSiteDetail, `Préciser le site d'insertion`,
    {
      sel: tools.oneTrue(
        tools.equals(result.fields.insertionSite.p1.field, 10),
        tools.equals(result.fields.insertionSite.r1.field, 10)
      )
    }
  )
}

// +++ ADD       firstDressing (list)
result.fields.firstDressing = {
  r1: tools.cfg.list(
    fields.firstDressing, `Premier pansement`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       insertionDate (date)
result.fields.insertionDate = {
  r1: tools.cfg.date(
    fields.insertionDate, `de la pose du cathéter`, {
      sel: result.select.yes(result.fields.firstDressing.r1.field)
    }
  )
}

// +++ ADD       lastDressingDate (date)
result.fields.lastDressingDate = {
  r1: tools.cfg.date(
    fields.lastDressingDate, `du dernier pansement`, {
      sel: result.select.no(result.fields.firstDressing.r1.field)
    }
  )
}

// +++ ADD       manipType (list)
result.fields.manipType = {
  b2: tools.cfg.list(
    fields.manipType, 'Type de manipulation', go.fields.manipType, { sel: result.select.b2 }
  )
}

// +++ ADD       otherManipType (text)
result.fields.otherManipType = {
  b2: tools.cfg.text(
    fields.otherManipType, 'Préciser le type de manipulation', {
      sel: tools.equals(result.fields.manipType.b2.field, 6)
    }
  )
}

// +++ ADD       p1audited (list)
result.fields.audited.p1 = tools.cfg.list(
  `p1${fields.audited}`, result.fields.audited.p1p3p4.config.title,
  go.fields.p1v2Audited, { sel: result.select.p1, srv: fields.audited }
)

// +++ ADD       p3p4r1audited (list)
result.fields.audited.p3p4r1 = tools.cfg.list(
  `p3p4r1${fields.audited}`, result.fields.audited.p1p3p4.config.title,
  go.fields.p3p4r1Audited, { sel: result.select.p3p4r1, srv: fields.audited }
)

// --- REMOVE    p1p3p4audited (list)
delete result.fields.audited.p1p3p4

// +++ ADD       p1auditedDetail (text)
result.fields.auditedDetail.p1 = tools.cfg.text(
  `p1${fields.auditedDetail}`, result.fields.auditedDetail.p1p3p4.config.title, {
    sel: tools.allTrue(
      result.select.p1,
      tools.equals(result.fields.audited.p1.field, 5)
    ),
    srv: fields.auditedDetail
  }
)

// +++ ADD       p3p4r1auditedDetail (text)
result.fields.auditedDetail.p3p4r1 = tools.cfg.text(
  `p3p4r1${fields.auditedDetail}`, result.fields.auditedDetail.p1p3p4.config.title, {
    sel: tools.allTrue(
      result.select.p3p4r1,
      tools.equals(result.fields.audited.p3p4r1.field, 5)
    ),
    srv: fields.auditedDetail
  }
)

// --- REMOVE    p1p3p4auditedDetail (text)
delete result.fields.auditedDetail.p1p3p4

// +++ ADD       auditedCleanOutfitOrProt (list)
result.fields.auditedCleanOutfitOrProt = {
  r1: tools.cfg.list(
    fields.auditedCleanOutfitOrProt,
    `Port d'une tenue propre ou protection à usage unique`, go.fields.yesNo,
    { sel: result.select.r1 }
  )
}

// +++ ADD       withUltrasound (list)
result.fields.withUltrasound = {
  p1: tools.cfg.list(
    fields.withUltrasound, `Le cathéter est-il posé sous échoguidage ?`,
    go.fields.yesNo, { sel: result.select.p1 }
  )
}

// +++ ADD       ultrasoundPrepared (list)
result.fields.ultrasoundPrepared = {
  p1: tools.cfg.list(
    fields.ultrasoundPrepared, `L'échographe est-il préparé ?`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.withUltrasound.p1.field)
      )
    }
  )
}

// +++ ADD       usAuditedPreparation (list)
result.fields.usAuditedPreparation = {
  p1: tools.cfg.list(
    fields.usAuditedPreparation,
    `L'opérateur prépare (ou participe à la préparation de) l'échographe`,
    go.fields.yesNo, {
      sel: result.select.yes(result.fields.ultrasoundPrepared.p1.field)
    }
  )
}

// +++ ADD       handHygieneBeforeP1UltrasoundPreparation (list)
// +++ ADD       handHygieneBeforeP1UltrasoundPreparationType (list)
// +++ ADD       handHygieneBeforeP1UltrasoundPreparationCompliant (list)
result.fields.handHygieneBeforeP1UltrasoundPreparation = {
  p1: result.build.handHygiene(
    fields.secondaryHandHygiene,
    'BeforeP1UltrasoundPreparation',
    `avant la préparation de l'échographe`,
    result.select.yes(result.fields.usAuditedPreparation.p1.field),
    null,
    go.fields.handHygieneTypeSimple
  )
}

function buildWiping (p, w) {
  return [
    tools.cfg.list(
      `${p}`, `Produit utilisé`,
      go.fields.wipingProduct, { sel: w }
    ),
    tools.cfg.text(
      `${p}Detail`, `Préciser le produit`, { sel: tools.equals(`${p}`, 3) }
    )
  ]
}

function buildUltrasoundWiping (f, s, i) {
  const wiping = `${fields.ultrasoundWiping}${f}`
  const product = `${wiping}Product`

  return [ tools.cfg.list(
    `${wiping}`, `Essuyage humide de la sonde ${s}`,
    go.fields.yesNo, { sel: i }
  ),
  ...buildWiping(product, result.select.yes(wiping))
  ]
}

result.build.ultrasoundWiping = buildUltrasoundWiping

// +++ ADD       ultrasoundWipingPrepa (list)
// +++ ADD       ultrasoundWipingPrepaProduct (list)
// +++ ADD       ultrasoundWipingPrepaProductDetail (text)
result.fields.ultrasoundWipingPrepa = {
  p1: buildUltrasoundWiping(
    'Prepa', `d'échographie`,
    result.select.yes(result.fields.usAuditedPreparation.p1.field)
  )
}

// +++ ADD       usAuditedSearch (list)
result.fields.usAuditedSearch = {
  p1: tools.cfg.list(
    fields.usAuditedSearch,
    `L'opérateur fait-il un repérage avant l'application de l'antiseptique ?`,
    go.fields.yesNo, { sel: result.select.yes(result.fields.withUltrasound.p1.field) }
  )
}

// +++ ADD       handHygieneBeforeP1UltrasoundSearch (list)
// +++ ADD       handHygieneBeforeP1UltrasoundSearchType (list)
// +++ ADD       handHygieneBeforeP1UltrasoundSearchCompliant (list)
result.fields.handHygieneBeforeP1UltrasoundSearch = {
  p1: result.build.handHygiene(
    fields.thirdHandHygiene, 'BeforeP1UltrasoundSearch', `avant le repérage`,
    result.select.yes(result.fields.usAuditedSearch.p1.field), null,
    go.fields.handHygieneType
  )
}

// +++ ADD       p1searchgloves (list)
result.fields.searchGloves = {
  p1: tools.cfg.list(
    `p1search${fields.gloves}`, 'Gants enfilés pour le repérage',
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.usAuditedSearch.p1.field),
        noGloves('p1', 'search')
      ),
      srv: fields.secondaryGloves
    }
  )
}

// +++ ADD       p1searchglovesType (list)
result.fields.searchGlovesType = {
  p1: tools.cfg.list(
    `p1search${fields.glovesType}`, `Type de gants`,
    go.fields.glovesWithDouble, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.searchGloves.p1.field)
      ),
      srv: fields.secondaryGlovesType
    }
  )
}

// +++ ADD       p1glovesRemoval (list)
result.fields.glovesRemoval = {
  p1: tools.cfg.list(
    `p1${fields.glovesRemoval}`,
    `Retrait des gants à la fin du repérage (ou d'une paire si double gantage)`,
    go.fields.yesNo, {
      sel: hasGloves('p1', 'search'), srv: fields.glovesRemoval
    }
  )
}

// +++ ADD       searchgelUsed (list)
result.fields.searchGelUsed = {
  p1: tools.cfg.list(
    `search${fields.gelUsed}`, 'Gel utilisé',
    go.fields.gelUsed, {
      sel: result.select.yes(result.fields.usAuditedSearch.p1.field),
      srv: fields.gelUsed
    }
  )
}

// +++ ADD       vialOpeningDateWritten (list)
result.fields.vialOpeningDateWritten = {
  p1: tools.cfg.list(
    fields.vialOpeningDateWritten, `Date d'ouverture notée sur le flacon`,
    go.fields.yesNo, { sel: tools.equals(result.fields.searchGelUsed.p1.field, 3) }
  )
}

// +++ ADD       vialOpenedSince (list)
result.fields.vialOpenedSince = {
  p1: tools.cfg.list(
    fields.vialOpenedSince, `Flacon ouvert depuis...`,
    go.fields.vialOpenedSince, {
      sel: result.select.yes(result.fields.vialOpeningDateWritten.p1.field)
    }
  )
}

// +++ ADD       searchultrasoundSheath (list)
result.fields.searchUltrasoundSheath = {
  p1: tools.cfg.list(
    `search${fields.ultrasoundSheath}`, `Utilisation d'une gaine / housse`,
    go.fields.ultrasoundSheath, {
      sel: result.select.yes(result.fields.usAuditedSearch.p1.field),
      srv: fields.ultrasoundSheath
    }
  )
}

// +++ ADD       ultrasoundWipingSearch (list)
// +++ ADD       ultrasoundWipingSearchProduct (list)
// +++ ADD       ultrasoundWipingSearchProductDetail (text)
result.fields.ultrasoundWipingSearch = {
  p1: buildUltrasoundWiping(
    'Search', `à la fin du réperage`,
    result.select.yes(result.fields.usAuditedSearch.p1.field)
  )
}

// +++ ADD       sheathRemoval (list)
result.fields.sheathRemoval = {
  p1: tools.cfg.list(
    fields.sheathRemoval,
    `La gaine / housse est-elle retirée après le repérage ?`,
    go.fields.yesNo, {
      sel: tools.different(result.fields.searchUltrasoundSheath.p1.field, 3)
    }
  )
}

// +++ ADD       strippingSufficient (list)
result.fields.strippingSufficient = {
  r1: tools.cfg.list(
    fields.strippingSufficient, `Dénudation du patient suffisante`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       bmi (numeric)
result.fields.bmi = {
  r1: tools.cfg.numeric(
    fields.bmi, `IMC`, 2,
    {
      sel: tools.allTrue(
        result.select.r1,
        tools.oneTrue(
          result.select.yes(result.fields.isAdult.p1p2p3r1.field),
          tools.equals2(result.fields.childAge.p1p2p3r1.field, 2, 3)
        )
      ),
      op: true,
      un: ''
    }
  )
}

// +++ ADD       scheduledDressingRepair (list)
result.fields.scheduledDressingRepair = {
  r1: tools.cfg.list(
    fields.scheduledDressingRepair, `Réfection programmée`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       soiledDressing (list)
result.fields.soiledDressing = {
  r1: tools.cfg.list(
    fields.soiledDressing, `Anticipée car pansement souillé`, go.fields.yesNo,
    { sel: result.select.no(result.fields.scheduledDressingRepair.r1.field) }
  )
}

// +++ ADD       dressingPeelsOff (list)
result.fields.dressingPeelsOff = {
  r1: tools.cfg.list(
    fields.dressingPeelsOff, `Anticipée car pansement décollé`, go.fields.yesNo,
    { sel: result.select.no(result.fields.scheduledDressingRepair.r1.field) }
  )
}

// +++ ADD       dressingWithCompresses (list)
result.fields.dressingWithCompresses = {
  r1: tools.cfg.list(
    fields.dressingWithCompresses, `Pansement en place avec compresses`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       sterileSemiPermeableTransparent (list)
result.fields.sterileSemiPermeableTransparent = {
  r1: tools.cfg.list(
    fields.sterileSemiPermeableTransparent,
    `Pansement en place transparent semi-perméable stérile`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       handHygieneBeforeEquipmentPreparation (list)
// +++ ADD       handHygieneBeforeEquipmentPreparationType (list)
// +++ ADD       handHygieneBeforeEquipmentPreparationCompliant (list)
result.fields.handHygieneBeforeEquipmentPreparation = {
  b2r1: result.build.handHygiene(
    fields.handHygiene, 'BeforeEquipmentPreparation', 'avant la préparation du matériel',
    result.select.b2r1, null, go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       sterilePreparation (list)
result.fields.sterilePreparation = {
  r1: tools.cfg.list(
    fields.sterilePreparation,
    `Préparation du matériel sur champ stérile et sur plan de travail désinfecté`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       r1removalgloves (list)
result.fields.removalGloves = {
  r1: tools.cfg.list(
    `r1removal${fields.gloves}`, 'Gants enfilés pour le retrait du pansement',
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.r1,
        noGloves('r1', 'removal')
      ),
      srv: fields.gloves
    }
  )
}

// +++ ADD       r1removalglovesType (list)
result.fields.removalGlovesType = {
  r1: tools.cfg.list(
    `r1removal${fields.glovesType}`, `Type de gants`,
    go.fields.gloves, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.removalGloves.r1.field)
      ),
      srv: fields.glovesType
    }
  )
}

// +++ ADD       removeDressingByStretching (list)
result.fields.removeDressingByStretching = {
  r1: tools.cfg.list(
    fields.removeDressingByStretching, `Retrait du pansement par étirement`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       signsOfSkinIrritation (list)
result.fields.signsOfSkinIrritation = {
  r1: tools.cfg.list(
    fields.signsOfSkinIrritation, `Signes d'irritation cutanée`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       r1glovesRemoval (list)
result.fields.glovesRemoval.r1 = tools.cfg.list(
  `r1${fields.glovesRemoval}`,
  `Retrait des gants`,
  go.fields.yesNo, {
    sel: hasGloves('r1', 'removal'),
    srv: fields.glovesRemoval
  }
)

// +++ ADD       handHygieneAfterR1Gloves (list)
// +++ ADD       handHygieneAfterR1GlovesType (list)
// +++ ADD       handHygieneAfterR1GlovesCompliant (list)
result.fields.handHygieneAfterR1Gloves = {
  r1: result.build.handHygiene(
    fields.secondaryHandHygiene, 'AfterR1Gloves', 'après le retrait des gants',
    result.select.yes(result.fields.glovesRemoval.r1.field),
    null, go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       hasStabilizer (list)
result.fields.hasStabilizer = {
  r1: tools.cfg.list(
    fields.hasStabilizer, `Présence d'un stabilisateur`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       changeStabilizer (list)
result.fields.changeStabilizer = {
  r1: tools.cfg.list(
    fields.changeStabilizer, `Changement du stabilisateur`,
    go.fields.yesNo, { sel: result.select.yes(result.fields.hasStabilizer.r1.field) }
  )
}

// +++ ADD       changeStabilizerReason (list)
result.fields.changeStabilizerReason = {
  r1: tools.cfg.list(
    fields.changeStabilizerReason, `Raison du changement`,
    go.fields.changeStabilizerReason,
    { sel: result.select.yes(result.fields.changeStabilizer.r1.field) }
  )
}

// +++ ADD       r1stabilizergloves (list)
result.fields.stabilizerGloves = {
  r1: tools.cfg.list(
    `r1stabilizer${fields.gloves}`, 'Gants enfilés pour le retrait du stabilisateur',
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.changeStabilizer.r1.field),
        noGloves('r1', 'stabilizer')
      ),
      srv: fields.secondaryGloves
    }
  )
}

// +++ ADD       r1stabilizerglovesType (list)
result.fields.stabilizerGlovesType = {
  r1: tools.cfg.list(
    `r1stabilizer${fields.glovesType}`, `Type de gants`,
    go.fields.gloves, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.stabilizerGloves.r1.field)
      ),
      srv: fields.secondaryGlovesType
    }
  )
}

// +++ ADD       r1secondaryGlovesRemoval (list)
result.fields.secondaryGlovesRemoval = {
  r1: tools.cfg.list(
    `r1${fields.secondaryGlovesRemoval}`,
    `Retrait des gants après le retrait du stabilisateur`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.yes(result.fields.changeStabilizer.r1.field),
        hasGloves('r1', 'stabilizer')
      ),
      srv: fields.secondaryGlovesRemoval
    }
  )
}

// +++ ADD       handHygieneAfterR1StabilizerGloves (list)
// +++ ADD       handHygieneAfterR1StabilizerGlovesType (list)
// +++ ADD       handHygieneAfterR1StabilizerGlovesCompliant (list)
result.fields.handHygieneAfterR1StabilizerGloves = {
  r1: result.build.handHygiene(
    fields.thirdHandHygiene, 'AfterR1StabilizerGloves', 'après le retrait des gants',
    result.select.yes(result.fields.secondaryGlovesRemoval.r1.field),
    null,
    go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       dressingSet (list)
result.fields.dressingSet = {
  r1: tools.cfg.list(
    fields.dressingSet, `Utilisation d'un set à pansement`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       r1repairgloves (list)
result.fields.repairGloves = {
  r1: tools.cfg.list(
    `r1repair${fields.gloves}`, `Gants enfilés pour l'antisepsie`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.r1,
        noGloves('r1', 'repair')
      ),
      srv: fields.thirdGloves
    }
  )
}

// +++ ADD       r1repairglovesType (list)
result.fields.repairGlovesType = {
  r1: tools.cfg.list(
    `r1repair${fields.glovesType}`, `Type de gants`,
    go.fields.gloves, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.repairGloves.r1.field)
      ),
      srv: fields.thirdGlovesType
    }
  )
}

// +++ ADD       auditedCleanSkin (list)
result.fields.auditedCleanSkin = {
  p1: tools.cfg.list(
    fields.auditedCleanSkin, `L'opérateur réalise-t-il le nettoyage de la peau ?`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.insertionSiteCleaned.p1p2p3p4r1.field)
      )
    }
  )
}

// --- REMOVE    handHygieneBeforeGloves (list)
// --- REMOVE    handHygieneBeforeGlovesType (list)
// --- REMOVE    handHygieneBeforeGlovesCompliant (list)
delete result.fields.handHygieneBeforeGloves

// +++ ADD       handHygieneBeforeP1SkinCleaning (list)
// +++ ADD       handHygieneBeforeP1SkinCleaningType (list)
// +++ ADD       handHygieneBeforeP1SkinCleaningCompliant (list)
result.fields.handHygieneBeforeP1SkinCleaning = {
  p1: result.build.handHygiene(
    fields.fourthHandHygiene,
    'BeforeP1SkinCleaning',
    'juste avant le nettoyage de la peau',
    tools.allTrue(
      result.select.p1, result.select.yes(result.fields.auditedCleanSkin.p1.field),
      noGloves('p1', 'skin')
    ),
    null,
    go.fields.handHygieneType
  )
}

// +++ ADD       p1skingloves (list)
result.fields.skinGloves = {
  p1: tools.cfg.list(
    `p1skin${fields.gloves}`, 'Gants enfilés pour le nettoyage de la peau',
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.auditedCleanSkin.p1.field),
        noGloves('p1', 'skin')
      ),
      srv: fields.thirdGloves
    }
  )
}

// +++ ADD       p1skinglovesType (list)
result.fields.skinGlovesType = {
  p1: tools.cfg.list(
    `p1skin${fields.glovesType}`, `Type de gants`,
    go.fields.glovesWithDouble, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.skinGloves.p1.field)
      ),
      srv: fields.thirdGlovesType
    }
  )
}

// +++ ADD       p1secondaryGlovesRemoval (list)
result.fields.secondaryGlovesRemoval.p1 = tools.cfg.list(
  `p1${fields.secondaryGlovesRemoval}`,
  `Retrait des gants après le nettoyage (ou d'une paire si double gantage)`,
  go.fields.yesNo, {
    sel: tools.allTrue(
      result.select.yes(result.fields.auditedCleanSkin.p1.field),
      hasGloves('p1', 'skin')
    ),
    srv: fields.secondaryGlovesRemoval
  }
)

// +++ ADD       r1soap (list)
result.fields.soap = {
  r1: tools.cfg.list(
    `r1${fields.soap}`, 'Type de savon', go.fields2024.soap, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.insertionSiteCleaned.p1p2p3p4r1.field)
      ),
      srv: fields.soap
    }
  )
}

// +++ ADD       rincing (list)
result.fields.rinsing = {
  r1: tools.cfg.list(
    fields.rinsing, `Rinçage avec de l'eau stérile ou du sérum physiologique`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.insertionSiteCleaned.p1p2p3p4r1.field)
      )
    }
  )
}

// +++ ADD       dryingWithSterileCompresses (list)
result.fields.dryingWithSterileCompresses = {
  r1: tools.cfg.list(
    fields.dryingWithSterileCompresses, `Séchage avec des compresses stériles`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.insertionSiteCleaned.p1p2p3p4r1.field)
      )
    }
  )
}

// +++ ADD       r1AntisepticApplied (list)
// +++ ADD       r1Antiseptic (list)
// +++ ADD       r1AntisepticOther (text)
result.fields.antiseptic.r1 = result.build.antiseptic(
  'Antiseptic', `Antisepsie du point de ponction`, `r1`, result.select.r1,
  go.fields.antiseptic
)

// +++ ADD       auditedApplyASQ (list)
result.fields.auditedApplyASQ = {
  p1: tools.cfg.list(
    fields.auditedApplyASQ, `L'opérateur participe ou réalise-t-il l'application de l'antiseptique`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1, result.select.yes(result.fields.antiseptic.p1p2p3p4[0].field)
      )
    }
  )
}

// +++ ADD       handHygieneBeforeP1Antiseptic (list)
// +++ ADD       handHygieneBeforeP1AntisepticType (list)
// +++ ADD       handHygieneBeforeP1AntisepticCompliant (list)
result.fields.handHygieneBeforeP1Antiseptic = {
  p1: result.build.handHygiene(
    fields.fifthHandHygiene, 'BeforeP1Antiseptic', `juste avant l'application de l'antiseptique`,
    tools.allTrue(
      result.select.p1, result.select.yes(result.fields.auditedApplyASQ.p1.field),
      noGloves('p1', 'antiseptic')
    ), null, go.fields.handHygieneType
  )
}

// +++ ADD       p1antisepticgloves (list)
result.fields.antisepticGloves = {
  p1: tools.cfg.list(
    `p1antiseptic${fields.gloves}`,
    `Gants enfilés pour appliquer l'antiseptique`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.auditedApplyASQ.p1.field),
        noGloves('p1', 'antiseptic')
      ),
      srv: fields.fourthGloves
    }
  )
}

// +++ ADD       p1antisepticglovesType (list)
result.fields.antisepticGlovesType = {
  p1: tools.cfg.list(
    `p1antiseptic${fields.glovesType}`, `Type de gants`,
    go.fields.glovesWithDouble, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.antisepticGloves.p1.field)
      ),
      srv: fields.fourthGlovesType
    }
  )
}

// +++ ADD       p1thirdGlovesRemoval (list)
result.fields.thirdGlovesRemoval = {
  p1: tools.cfg.list(
    `p1${fields.thirdGlovesRemoval}`,
    `Retrait des gants après l'application de l'antiseptique (ou d'une paire si double gantage)`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.yes(result.fields.auditedApplyASQ.p1.field),
        hasGloves('p1', 'antiseptic')
      ),
      srv: fields.thirdGlovesRemoval
    }
  )
}

// +++ ADD       r1UseCompresses (list)
result.fields.useCompresses.r1 = tools.cfg.list(
  `r1UseCompresses`, `Utilisation de compresses pour l'antisepsie`,
  go.fields.yesNoSo, {
    sel: tools.allTrue(
      result.select.r1,
      result.select.yes(result.fields.antiseptic.r1[0].field),
      tools.different(result.fields.antiseptic.r1[1].field, 7)
    ),
    srv: fields.useCompresses
  }
)

// +++ ADD       r1CompressesType (list)
result.fields.compressesType.r1 = tools.cfg.list(
  `r1CompressesType`, `Type de compresses`, go.fields.compresses,
  {
    sel: tools.allTrue(
      result.select.r1,
      result.select.yes(result.fields.useCompresses.r1.field)
    ),
    srv: fields.compressesType
  }
)

// +++ ADD       r1dry (list)
result.fields.dry.r1 = tools.cfg.list(
  `r1${fields.dry}`,
  result.fields.dry.p1p2p3p4.config.title, go.fields.yesNo, {
    sel: tools.allTrue(
      result.select.r1, result.select.yes(result.fields.antiseptic.r1[0].field)
    ),
    srv: fields.dry
  }
)

// +++ ADD       r1thirdGlovesRemoval (list)
result.fields.thirdGlovesRemoval.r1 = tools.cfg.list(
  `r1${fields.thirdGlovesRemoval}`,
  `Retrait des gants après l'antisepsie`,
  go.fields.yesNo, {
    sel: hasGloves('r1', 'repair'),
    srv: fields.thirdGlovesRemoval
  }
)

// +++ ADD       handHygieneAfterR1RepairGloves (list)
// +++ ADD       handHygieneAfterR1RepairGlovesType (list)
// +++ ADD       handHygieneAfterR1RepairGlovesCompliant (list)
result.fields.handHygieneAfterR1RepairGloves = {
  r1: result.build.handHygiene(
    fields.fourthHandHygiene, 'AfterR1RepairGloves', 'après le retrait des gants',
    result.select.yes(result.fields.thirdGlovesRemoval.r1.field), null,
    go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       handHygieneBeforeB2Manip (list)
// +++ ADD       handHygieneBeforeB2ManipType (list)
// +++ ADD       handHygieneBeforeB2ManipCompliant (list)
result.fields.handHygieneBeforeB2Manip = {
  b2: result.build.handHygiene(
    fields.secondaryHandHygiene, 'BeforeB2Manip',
    'avant la manipulation du site de branchement',
    result.select.b2, null, go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       r1implementationgloves (list)
result.fields.implementationGloves = {
  r1: tools.cfg.list(
    `r1implementation${fields.gloves}`,
    'Gants enfilés pour la mise en place du pansement',
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.r1,
        noGloves('r1', 'implementation')
      ),
      srv: fields.fourthGloves
    }
  )
}

// +++ ADD       r1implementationglovesType (list)
result.fields.implementationGlovesType = {
  r1: tools.cfg.list(
    `r1implementation${fields.glovesType}`, `Type de gants`,
    go.fields.gloves, {
      sel: tools.allTrue(
        result.select.r1,
        result.select.yes(result.fields.implementationGloves.r1.field)
      ),
      srv: fields.fourthGlovesType
    }
  )
}

// +++ ADD       newStabilizer (list)
result.fields.newStabilizer = {
  r1: tools.cfg.list(
    fields.newStabilizer, `Mise en place d'un nouveau stabilisateur`,
    go.fields.yesNoSo, {
      sel: tools.allTrue(
        result.select.r1,
        tools.oneTrue(
          result.select.no(result.fields.hasStabilizer.r1.field),
          result.select.yes(result.fields.changeStabilizer.r1.field)
        )
      )
    }
  )
}

// +++ ADD       antiPeelingProduct (list)
result.fields.antiPeelingProduct = {
  r1: tools.cfg.list(
    fields.antiPeelingProduct, `Utilisation d'un produit anti-décollement`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       newDressingWithCompresses (list)
result.fields.newDressingWithCompresses = {
  r1: tools.cfg.list(
    fields.newDressingWithCompresses, `Pansement mis en place avec compresses`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       newDressingSterileSemiPermeableTransparent (list)
result.fields.newDressingSterileSemiPermeableTransparent = {
  r1: tools.cfg.list(
    fields.newDressingSterileSemiPermeableTransparent, `Pansement transparent semi-perméable stérile`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       newDressingImpregnated (list)
result.fields.newDressingImpregnated = {
  r1: tools.cfg.list(
    fields.newDressingImpregnated, `Pansement imprégné d'antiseptique`,
    go.fields.yesNo, { sel: result.select.r1 }
  )
}

// +++ ADD       r1fourthGlovesRemoval (list)
result.fields.fourthGlovesRemoval = {
  r1: tools.cfg.list(
    `r1${fields.fourthGlovesRemoval}`,
    `Retrait des gants`,
    go.fields.yesNo, {
      sel: hasGloves('r1', 'implementation'),
      srv: fields.fourthGlovesRemoval
    }
  )
}

// +++ ADD       handHygieneAfterR1ImplementationGloves (list)
// +++ ADD       handHygieneAfterR1ImplementationGlovesType (list)
// +++ ADD       handHygieneAfterR1ImplementationGlovesCompliant (list)
result.fields.handHygieneAfterR1ImplementationGloves = {
  r1: result.build.handHygiene(
    fields.fifthHandHygiene, 'AfterR1ImplementationGloves', 'après le retrait des gants',
    result.select.yes(result.fields.fourthGlovesRemoval.r1.field), null,
    go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       glovesPutOnManip (list)
result.fields.glovesPutOnManip = {
  b2: tools.cfg.list(
    fields.glovesPutOnManip, `Gants enfilés`,
    go.fields.glovesPutOnManip, {
      sel: tools.allTrue(
        result.select.b2,
        result.select.yes(result.fields.gloves.b2.field)
      )
    }
  )
}

//     UPDATE    handHygieneBeforeInsertion (list)handHygieneBeforeInsertion>config>title: different values (Hygiène des mains avant la pose du dispositif / Hygiène des mains immédiatement avant la pose du dispositif)
//     UPDATE    handHygieneBeforeInsertion (list)handHygieneBeforeInsertion>selectList>0/0: different function names "(obsManagment === 1)" "allTrue ((obsManagment === 1), )}"
//     UPDATE    handHygieneBeforeInsertionType (list)handHygieneBeforeInsertionType>config>title: different values (Désinfection chirurgicale des mains / Désinfection des mains)
//     UPDATE    handHygieneBeforeInsertionType (list)handHygieneBeforeInsertionType>config>values: different sizes
result.fields.handHygieneBeforeInsertion.p1 = result.build.handHygiene(
  fields.handHygiene, 'BeforeInsertion', 'immédiatement avant la pose du dispositif',
  tools.allTrue(result.select.p1, noGloves('p1', 'insertion')), null,
  go.fields.handHygieneType
)

// +++ ADD       p2p3p4b1gloves (list)
// --- REMOVE    p1p2p3p4b1gloves (list)
result.fields.gloves = (function () {
  const reference = result.fields.gloves.p1p2p3p4b1
  const t = reference.config.title
  const v = reference.config.values

  return {
    b2: result.fields.gloves.b2,
    p2p3p4b1: tools.cfg.list(
      `p2p3p4b1${fields.gloves}`, t, v, {
        sel: result.select.p2p3p4b1, srv: fields.gloves
      }
    )
  }
})()

// +++ ADD       p2p3p4b1glovesType (list)
// --- REMOVE    p1p2p3p4b1glovesType (list)
result.fields.glovesType = (function () {
  const reference = result.fields.glovesType.p1p2p3p4b1
  const t = reference.config.title
  const v = reference.config.values

  return {
    b2: result.fields.glovesType.b2,
    p2p3p4b1: tools.cfg.list(
      `p2p3p4b1${fields.glovesType}`, t, v, {
        sel: tools.allTrue(
          result.fields.gloves.p2p3p4b1.selectList._list[0],
          result.select.yes(result.fields.gloves.p2p3p4b1.field)
        ),
        srv: fields.glovesType
      }
    )
  }
})()

// +++ ADD       p1insertiongloves (list)
result.fields.insertionGloves = {
  p1: tools.cfg.list(
    `p1insertion${fields.gloves}`,
    'Gants enfilés immédiatement avant la pose du dispositif',
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1,
        noGloves('p1', 'insertion')
      ),
      srv: fields.gloves
    }
  )
}

// +++ ADD       p1insertionglovesType (list)
result.fields.insertionGlovesType = {
  p1: tools.cfg.list(
    `p1insertion${fields.glovesType}`, `Type de gants`,
    go.fields.glovesWithDouble, {
      sel: tools.allTrue(
        result.select.p1,
        result.select.yes(result.fields.insertionGloves.p1.field)
      ),
      srv: fields.glovesType
    }
  )
}

// +++ ADD       insertionultrasoundSheath (list)
result.fields.insertionUltrasoundSheath = {
  p1: tools.cfg.list(
    `insertion${fields.ultrasoundSheath}`, `L'opérateur utilise une gaine / housse sur la sonde`,
    go.fields.ultrasoundSheath, {
      sel: tools.allTrue(
        result.select.yes(result.fields.withUltrasound.p1.field),
        tools.oneTrue(
          result.select.no(result.fields.usAuditedSearch.p1.field),
          tools.equals(result.fields.searchUltrasoundSheath.p1.field, 3),
          result.select.yes(result.fields.sheathRemoval.p1.field)
        )
      ),
      srv: fields.secondUltrasoundSheath
    }
  )
}

// +++ ADD       probeCovered (list)
result.fields.probeCovered = {
  p1: tools.cfg.list(
    fields.probeCovered, 'Sonde et câble recouverts par la gaine / housse',
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.yes(result.fields.withUltrasound.p1.field),
        tools.oneTrue(
          result.select.no(result.fields.sheathRemoval.p1.field),
          tools.different(result.fields.insertionUltrasoundSheath.p1.field, 3)
        )
      )
    }
  )
}

// +++ ADD       sheathJustBeforeInsertion (list)
result.fields.sheathJustBeforeInsertion = {
  p1: tools.cfg.list(
    fields.sheathJustBeforeInsertion, `Gaine / housse installée immédiatement avant la pose du cathéter`,
    go.fields.yesNo, {
      sel: tools.different(result.fields.insertionUltrasoundSheath.p1.field, 3)
    }
  )
}

// +++ ADD       insertiongelUsed (list)
result.fields.insertionGelUsed = {
  p1: tools.cfg.list(
    `insertion${fields.gelUsed}`, 'Gel utilisé', go.fields.gelUsed, {
      sel: result.select.yes(result.fields.withUltrasound.p1.field),
      srv: fields.secondGelUsed
    }
  )
}

// +++ ADD       gelApplied (list)
result.fields.gelApplied = {
  p1: tools.cfg.list(
    fields.gelApplied, `Où le gel est-il appliqué ?`, go.fields.gelApplied, {
      sel: result.select.yes(result.fields.withUltrasound.p1.field)
    }
  )
}

// +++ ADD       probeNeedleContact (list)
result.fields.probeNeedleContact = {
  p1: tools.cfg.list(
    fields.probeNeedleContact, `Contact entre sonde et aiguille pendant l'insertion du cathéter`,
    go.fields.yesNo, {
      sel: result.select.yes(result.fields.withUltrasound.p1.field)
    }
  )
}

// +++ ADD       auditedTouchProbe (list)
result.fields.auditedTouchProbe = {
  p1: tools.cfg.list(
    fields.auditedTouchProbe, `L'opérateur touche l'échographe pendant l'insertion du cathéter`,
    go.fields.yesNo, {
      sel: result.select.yes(result.fields.withUltrasound.p1.field)
    }
  )
}

// +++ ADD       probeTouchedWith (list)
result.fields.probeTouchedWith = {
  p1: tools.cfg.list(
    fields.probeTouchedWith, `Comment l'échographe est-il touché ?`,
    go.fields.probeTouchedWith, {
      sel: result.select.yes(result.fields.auditedTouchProbe.p1.field)
    }
  )
}

// +++ ADD       probeTouchedWithDetail (text)
result.fields.probeTouchedWithDetail = {
  p1: tools.cfg.text(
    `${result.fields.probeTouchedWith.p1.field}Detail`, 'Préciser', {
      sel: tools.equals(result.fields.probeTouchedWith.p1.field, 4)
    }
  )
}

// +++ ADD       p1fourthGlovesRemoval (list)
result.fields.fourthGlovesRemoval.p1 = tools.cfg.list(
  `p1${fields.fourthGlovesRemoval}`,
  `Retrait des gants après avoir touché l'échographe (ou d'une paire si double gantage)`,
  go.fields.yesNo, {
    sel: tools.allTrue(
      tools.equals(result.fields.probeTouchedWith.p1.field, 1),
      hasGloves('p1', '')
    ),
    srv: fields.fourthGlovesRemoval
  }
)

// >>> UPDATE    glovesPutOn (list)     glovesPutOn>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 3), (obsManagment === 6)), (p2p3p4b1gloves === 1))" "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (p1p2p3p4b1gloves === 1))}"
result.fields.glovesPutOn = {
  p2p3p4: tools.cfg.list(
    fields.glovesPutOn, 'Gants enfilés', go.fields2023.glovesPutOn, {
      sel: tools.allTrue(
        result.select.p2p3p4, result.select.yes(result.fields.gloves.p2p3p4b1.field)
      )
    }
  )
}

// +++ ADD       preFencedSterileField (list)
result.fields.preFencedSterileField = {
  p3: tools.cfg.list(
    fields.preFencedSterileField,
    `Installation d'un champs stérile troué et préfendu`,
    go.fields.yesNo, { sel: result.select.p3 }
  )
}

// +++ ADD       chpSwabbing (list)
result.fields.chpSwabbing = {
  p3b2: tools.cfg.list(
    fields.chpSwabbing, `Écouvillonage réalisé immédiatement avant la manipulation proximale (CleanHand PROX)`,
    go.fields.yesNo, { sel: result.select.p3b2 }
  )
}

// +++ ADD       chpSwabNumber (numeric)
result.fields.chpSwabNumber = {
  p3b2: tools.cfg.numeric(
    fields.chpSwabNumber, `Numéro CLEANHAND PROX`, 2, {
      sel: result.select.yes(result.fields.chpSwabbing.p3b2.field)
    }
  )
}

// +++ ADD       nakedEyeSheathInspection (list)
result.fields.nakedEyeSheathInspection = {
  p1: tools.cfg.list(
    fields.nakedEyeSheathInspection,
    `La gaine / housse est-elle inspectée à l'oeil nu après l'insertion ?`,
    go.fields.yesNo, {
      sel:
      tools.allTrue(
        result.select.yes(result.fields.withUltrasound.p1.field),
        tools.oneTrue(
          tools.different(result.fields.insertionUltrasoundSheath.p1.field, 3),
          result.select.no(result.fields.sheathRemoval.p1.field)
        )
      )
    }
  )
}

// +++ ADD       probeInspection (list)
result.fields.probeInspection = {
  p1: tools.cfg.list(
    fields.probeInspection, `Comment la sonde (ou gel) est-elle inspectée ?`,
    go.fields.probeInspection, {
      sel: result.select.yes(result.fields.withUltrasound.p1.field)
    }
  )
}

// +++ ADD       tearedSheath (list)
result.fields.tearedSheath = {
  p1: tools.cfg.list(
    fields.tearedSheath, `La gaine / housse présente-t-elle une déchirure ?`,
    go.fields.yesNo, {
      sel: result.select.yes(result.fields.nakedEyeSheathInspection.p1.field)
    }
  )
}

// +++ ADD       dirtyProbe (list)
result.fields.dirtyProbe = {
  p1: tools.cfg.list(
    fields.dirtyProbe, `La sonde (ou gel) présente-t-elle des salissures ?`,
    go.fields.yesNo, {
      sel: tools.different(result.fields.probeInspection.p1.field, 3)
    }
  )
}

// +++ ADD       probeCleaned (list)
result.fields.probeCleaned = {
  p1: tools.cfg.list(
    fields.probeCleaned, `La sonde est-elle immédiatement entretenue ?`,
    go.fields.yesNo, {
      sel: result.select.yes(result.fields.withUltrasound.p1.field)
    }
  )
}

// +++ ADD       probeCleaningMethod (list)
result.fields.probeCleaningMethod = {
  p1: tools.cfg.list(
    fields.probeCleaningMethod, `Comment la sonde a-t-elle été entrenue ?`,
    go.fields.probeCleaningMethod, {
      sel: result.select.yes(result.fields.probeCleaned.p1.field)
    }
  )
}

// +++ ADD       probeCleaningMethodDetail (text)
result.fields.probeCleaningMethodDetail = {
  p1: tools.cfg.text(
    `${result.fields.probeCleaningMethod.p1.field}Detail`, `Préciser`, {
      sel: tools.equals(result.fields.probeCleaningMethod.p1.field, 3)
    }
  )
}

// +++ ADD       probeCleaningProduct (list)
// +++ ADD       probeCleaningProductDetail (text)
result.fields.probeCleaningProduct = {
  p1: buildWiping(
    fields.probeCleaningProduct,
    tools.equals(result.fields.probeCleaningMethod.p1.field, 1)
  )
}

// +++ ADD       whyNotHHAfterDressingRemoval (list)
// +++ ADD       whyNotHHAfterDressingRemovalDetail (text)
result.fields.whyNotHHAfterDressingRemoval = {
  r1: result.build.why(
    '', fields.whyNotHHAfterDressingRemoval,
    `Pourquoi l'HDM n'est pas réalisée au retrait des gants après le retrait du pansement ?`,
    tools.allTrue(
      result.select.r1,
      result.select.yes(result.fields.glovesRemoval.r1.field),
      result.select.no(result.fields.handHygieneAfterR1Gloves.r1[0].field)
    ),
    go.fields.whyNotHHP,
    5
  )
}

// +++ ADD       whyNotGROnStabilizerChange (list)
// +++ ADD       whyNotGROnStabilizerChangeDetail (text)
result.fields.whyNotGROnStabilizerChange = {
  r1: result.build.why(
    '', fields.whyNotGROnStabilizerChange,
    `Pourquoi les gants n'ont-ils pas été changés après le retrait du stabilisateur ?`,
    tools.allTrue(
      result.select.r1,
      result.select.no(result.fields.secondaryGlovesRemoval.r1.field)
    ),
    go.fields.whyNotGROnStabilizerChange,
    5
  )
}

// +++ ADD       whyNotHHAfterStabilizerGR (list)
// +++ ADD       whyNotHHAfterStabilizerGRDetail (text)
result.fields.whyNotHHAfterStabilizerGR = {
  r1: result.build.why(
    '', fields.whyNotHHAfterStabilizerGR,
    `Pourquoi l'HDM n'est pas réalisée au retrait des gants après le retrait du stabilisateur ?`,
    tools.allTrue(
      result.select.r1,
      result.select.yes(result.fields.secondaryGlovesRemoval.r1.field),
      result.select.no(result.fields.handHygieneAfterR1StabilizerGloves.r1[0].field)
    ),
    go.fields.whyNotAlcool,
    4
  )
}

// +++ ADD       whyNotSGForAntisepsis (list)
// +++ ADD       whyNotSGForAntisepsisDetail (text)
result.fields.whyNotSGForAntisepsis = {
  r1: result.build.why(
    '', fields.whyNotSGForAntisepsis,
    `Pourquoi les gants ne sont-ils pas stériles pour la réfection du pansement ?`,
    tools.allTrue(
      result.select.r1,
      tools.equals(result.fields.repairGlovesType.r1.field, 1)
    ),
    go.fields.whyNotSGForAntisepsis,
    5
  )
}

// +++ ADD       whySheathNotRemovedAfterSearch (list)
// +++ ADD       whySheathNotRemovedAfterSearchDetail (text)
result.fields.whySheathNotRemovedAfterSearch = {
  p1: result.build.why(
    '', fields.whySheathNotRemovedAfterSearch,
    `Pourquoi l'opérateur ne retire-t-il pas la gaine après le repérage ?`,
    tools.allTrue(result.select.p1, result.select.no(result.fields.sheathRemoval.p1.field)),
    go.fields.whySheathNotRemovedAfterSearch,
    4
  )
}

// +++ ADD       r1whyNotAlcool (list)
// +++ ADD       r1whyNotAlcoolDetail (text)
result.fields.whyNotAlcool.r1 = result.build.notAlcool(
  'r1', [1, 3, 4, 6, 9],
  tools.allTrue(result.select.r1, result.select.yes(result.fields.isAdult.p1p2p3r1.field)),
  'r1'
)

// >>> UPDATE    whyNotGloves (list)    whyNotGloves>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (p2p3p4b1gloves === 2))" "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (p1p2p3p4b1gloves === 2))}"
result.fields.whyNotGloves.p2p4[0] = tools.select(
  result.fields.whyNotGloves.p2p4[0],
  tools.allTrue(
    result.select.p2p4,
    result.select.no(result.fields.gloves.p2p3p4b1.field)
  )
)

// >>> UPDATE    b2whyNotHHM (list)     b2whyNotHHM>config>title: different values (Pourquoi l'HDM n'a-t-elle pas été réalisée immédiatement avant la manipulation du site de branchement? / Pourquoi l'HDM n'a-t-elle pas été réalisée avant la manipulation ?)
// >>> UPDATE    b2whyNotHHM (list)     b2whyNotHHM>selectList>0/0: different function names "allTrue ((obsManagment === 5), (handHygieneBeforeB2Manip === 2))" "allTrue ((obsManagment === 5), (handHygieneBeforeGloves === 2))}"
result.fields.whyNotHHM.b2 = result.build.why(
  'b2', fields.whyNotHHM,
  `Pourquoi l'HDM n'a-t-elle pas été réalisée immédiatement avant la manipulation du site de branchement?`,
  tools.allTrue(
    result.select.b2,
    result.select.no(result.fields.handHygieneBeforeB2Manip.b2[0].field)
  ),
  go.fields.whyNotHHM,
  5
)
// +++ ADD       whyNotRemoveGlovesAfterTouch (list)
// +++ ADD       whyNotRemoveGlovesAfterTouchDetail (text)
result.fields.whyNotRemoveGlovesAfterTouch = {
  p1: result.build.why(
    '', fields.whyNotRemoveGlovesAfterTouch,
    `Pendant l'insertion du cathéter, pourquoi l'opérateur a-t-il poursuivi l'insertion du cathéter avec des gants ayant touchés le clavier de l'échographe ?`,
    tools.allTrue(
      result.select.p1, result.select.no(result.fields.fourthGlovesRemoval.p1.field)
    ),
    go.fields.whyNotRemoveGlovesAfterTouch,
    4
  )
}

const glovesList = {
  p1: [
    'search',
    'skin',
    'antiseptic',
    'insertion'
  ],

  r1: [
    'removal',
    'stabilizer',
    'repair',
    'implementation'
  ]
}

const glovesRemoval = {
  r1: {
    removal: result.fields.glovesRemoval.r1,
    stabilizer: result.fields.secondaryGlovesRemoval.r1,
    repair: result.fields.thirdGlovesRemoval.r1,
    implementation: result.fields.fourthGlovesRemoval.r1
  },

  p1: {
    search: result.fields.glovesRemoval.p1,
    skin: result.fields.secondaryGlovesRemoval.p1,
    antiseptic: result.fields.thirdGlovesRemoval.p1,
    touch: result.fields.fourthGlovesRemoval.p1
  }
}

const glovesType = {
  r1: {
    removal: result.fields.removalGlovesType.r1,
    stabilizer: result.fields.stabilizerGlovesType.r1,
    repair: result.fields.repairGlovesType.r1,
    implementation: result.fields.implementationGlovesType.r1
  },
  p1: {
    search: result.fields.searchGlovesType.p1,
    skin: result.fields.skinGlovesType.p1,
    antiseptic: result.fields.antisepticGlovesType.p1,
    insertion: result.fields.insertionGlovesType.p1
  }
}

function countGloves (sheet, type, target, removal) {
  let count = 0

  const gt = glovesType[type]
  const gr = glovesRemoval[type]
  const fl = glovesList[type]

  let parse = true
  for (let i = 0; parse && i !== fl.length; ++i) {
    const l = fl[i]
    parse = l !== target
    if (!removal && !parse) {
      break
    }

    if (count === 0) {
      const v = sheet[gt[l].field]
      if (v == null) {
        continue
      }
      count = v === 3 ? 2 : 1
    }

    if (!parse) {
      break
    }

    const r = gr[l]
    if (count > 0 && r != null) {
      const v = sheet[r.field]
      if (v === 1) {
        --count
      }
    }
  }
  return count
}

function noGloves (p, t) {
  const result = (d) => countGloves(d, p, t, false) === 0
  Object.defineProperty(result, 'name', { value: `(hasGloves ${p} ${t})` })
  return result
}

function hasGloves (p, t) {
  const result = (d) => countGloves(d, p, t, true) > 0
  Object.defineProperty(result, 'name', { value: `(hasGloves ${p} ${t})` })
  return result
}

result.select.noGloves = noGloves
result.select.hasGloves = hasGloves
result.select.countGloves = countGloves

result.titles.audited.p1 = result.build.titleFrom(
  result.titles.audited.p1p3p4, result.fields.audited.p1
)

result.titles.audited.p3p4r1 = result.build.titleFrom(
  result.titles.audited.p1p3p4, result.fields.audited.p3p4r1
)
delete result.titles.audited.p1p3p4

result.titles.patient.p1p2p3b2r1 = result.build.titleFrom(
  result.titles.patient.p1p2p3b2, result.fields.isAdult.p1p2p3r1,
  result.select.p1p2p3b2r1
)

result.titles.ultrasound = {
  p1: result.build.title(
    `ÉCHOGUIDAGE`, result.fields.withUltrasound.p1,
    false, result.select.p1
  )
}

result.titles.ultrasoundPreparation = {
  p1: result.build.title(
    `PRÉPARATION DE L'ÉCHOGRAPHE`,
    result.fields.ultrasoundPrepared.p1,
    false,
    result.select.yes(result.fields.withUltrasound.p1.field),
    'subtitle'
  )
}

result.titles.ultrasoundSearch = {
  p1: result.build.title(
    `REPÉRAGE`,
    result.fields.usAuditedSearch.p1,
    false,
    result.select.yes(result.fields.withUltrasound.p1.field),
    'subtitle'
  )
}

result.titles.padRemoval = {
  r1: result.build.title(
    `RETRAIT DU PANSEMENT EN PLACE`,
    result.fields.scheduledDressingRepair.r1,
    false,
    result.select.r1
  )
}

result.titles.insertionSite = {
  p2p4: result.build.titleFrom(
    result.titles.insertionSite.p1p2p4,
    result.fields.handHygieneBeforePreparation.p2p3p4[0],
    result.select.p2p4
  ),

  p1: result.build.title(
    `PRÉPARATION CUTANÉE DU SITE D'INSERTION (ANTISEPSIE)`,
    result.fields.handHygieneBeforePreparation.p2p3p4[0],
    false,
    result.select.p1
  ),

  p3: result.titles.insertionSite.p3
}

result.titles.manipulation.b2 = result.build.titleFrom(
  result.titles.manipulation.b2,
  result.fields.handHygieneBeforeEquipmentPreparation.b2r1[0],
  result.select.b2
)

result.titles.changePad = {
  r1: result.build.title(
    `RÉFECTION DU PANSEMENT`,
    result.fields.hasStabilizer.r1,
    false,
    result.select.r1
  )
}

result.titles.newPad = {
  r1: result.build.title(
    `PANSEMENT MIS EN PLACE`,
    result.fields.newDressingWithCompresses.r1,
    false,
    result.select.r1,
    'subtitle'
  )
}

result.titles.glovesRemoval = {
  r1: result.build.title(
    'RETRAIT DES GANTS',
    result.fields.fourthGlovesRemoval.r1,
    false,
    hasGloves('r1', 'implementation'),
    'subtitle'
  )
}

result.titles.insertionWithUltrasound = {
  p1: result.build.title(
    `SI POSE SOUS ÉCHOGUIDAGE`,
    result.fields.insertionUltrasoundSheath.p1,
    false,
    result.select.yes(result.fields.withUltrasound.p1.field),
    'subtitle'
  )
}

result.titles.probeHandling = {
  p1: result.build.title(
    `À LA FIN DE LA POSE DU CATHÉTER : GESTION DE LA SONDE`,
    result.fields.nakedEyeSheathInspection.p1,
    false,
    result.select.yes(result.fields.withUltrasound.p1.field),
    'subtitle'
  )
}

result.sheet = {
  titles: [
    result.titles.audited.p1,
    result.titles.audited.p3p4r1,
    result.titles.audited.p2b1b2,
    result.titles.patient.p1p2p3b2r1,
    result.titles.patient.p4,
    result.titles.ultrasound.p1,
    result.titles.ultrasoundPreparation.p1,
    result.titles.ultrasoundSearch.p1,
    result.titles.padRemoval.r1,
    result.titles.insertionSite.p2p4,
    result.titles.insertionSite.p1,
    result.titles.insertionSite.p3,
    result.titles.manipulation.b1,
    result.titles.manipulation.b2,
    result.titles.changePad.r1,
    result.titles.newPad.r1,
    result.titles.glovesRemoval.r1,
    result.titles.insertion.p1,
    result.titles.insertion.p2p4,
    result.titles.insertion.p3,
    result.titles.insertionWithUltrasound.p1,
    result.titles.probeHandling.p1,
    result.titles.interview.all
  ],

  fields: [
    result.fields.obsManagment.all,
    ...tools.addSelect(result.select.obs, [
      patient.sheetNumber.v2,
      result.fields.obsDate.all
    ]),
    result.fields.isEhpad.p4,
    ...tools.addSelect(result.select.obs, [
      tools.opts(patient.unitType.v1.rw, { sp: 'unitType' }),
      patient.uf
    ]),
    result.fields.place.p1,
    result.fields.otherPlace.p1,
    result.fields.catheterType.p1,
    result.fields.catheterType.p2,
    result.fields.catheterType.b1,
    result.fields.catheterType.b2,
    result.fields.catheterType.p4,
    result.fields.catheterType.r1,
    result.fields.otherCatheterType.p1,
    result.fields.otherCatheterType.b1,
    result.fields.otherCatheterType.b2,
    result.fields.otherCatheterType.r1,
    result.fields.insertionSite.r1,
    result.fields.insertionSite.p1,
    result.fields.insertionSiteDetail.p1r1,
    result.fields.firstDressing.r1,
    result.fields.insertionDate.r1,
    result.fields.lastDressingDate.r1,
    result.fields.manipType.b2,
    result.fields.otherManipType.b2,
    result.fields.audited.p1,
    result.fields.audited.p3p4r1,
    result.fields.audited.p2b1b2,
    result.fields.auditedDetail.p3p4r1,
    result.fields.auditedDetail.p1,
    result.fields.student.all,
    result.fields.auditedCleanOutfit.p2p3p4b1b2,
    result.fields.auditedCleanOutfitOrProt.r1,
    result.fields.sterileGown.p1,
    result.fields.auditedCap.p1p3r1,
    result.fields.compliantAuditedCap.p1p3r1,
    result.fields.auditedMask.p1p3b2r1,
    result.fields.compliantAuditedMask.p1p3b2r1,
    result.fields.isAdult.p1p2p3r1,
    result.fields.childAge.p1p2p3r1,
    result.fields.patientCleanOutfit.p1p2p3p4b2,
    result.fields.patientMask.p1p3b2r1,
    result.fields.compliantPatientMask.p1p3b2r1,
    result.fields.patientSterileField.p1r1,
    result.fields.patientOtherSide.p3b2r1,
    result.fields.patientCap.p1,
    result.fields.compliantPatientCap.p1,
    result.fields.withUltrasound.p1,
    result.fields.ultrasoundPrepared.p1,
    result.fields.usAuditedPreparation.p1,
    ...result.fields.handHygieneBeforeP1UltrasoundPreparation.p1,
    ...result.fields.ultrasoundWipingPrepa.p1,
    result.fields.usAuditedSearch.p1,
    ...result.fields.handHygieneBeforeP1UltrasoundSearch.p1,
    result.fields.searchGloves.p1,
    result.fields.searchGlovesType.p1,
    result.fields.glovesRemoval.p1,
    result.fields.searchGelUsed.p1,
    result.fields.vialOpeningDateWritten.p1,
    result.fields.vialOpenedSince.p1,
    result.fields.searchUltrasoundSheath.p1,
    ...result.fields.ultrasoundWipingSearch.p1,
    result.fields.sheathRemoval.p1,
    result.fields.strippingSufficient.r1,
    result.fields.bmi.r1,
    result.fields.scheduledDressingRepair.r1,
    result.fields.soiledDressing.r1,
    result.fields.dressingPeelsOff.r1,
    result.fields.dressingWithCompresses.r1,
    result.fields.sterileSemiPermeableTransparent.r1,

    ...result.fields.handHygieneBeforePreparation.p2p3p4,
    ...result.fields.handHygieneBeforeManip.b1,
    ...result.fields.handHygieneBeforeEquipmentPreparation.b2r1,

    result.fields.sterilePreparation.r1,
    result.fields.dirtySkin.p1p2p3p4,

    result.fields.removalGloves.r1,
    result.fields.removalGlovesType.r1,
    result.fields.removeDressingByStretching.r1,
    result.fields.signsOfSkinIrritation.r1,

    result.fields.glovesRemoval.r1,

    ...result.fields.handHygieneAfterR1Gloves.r1,
    result.fields.hasStabilizer.r1,
    result.fields.changeStabilizer.r1,
    result.fields.changeStabilizerReason.r1,
    result.fields.stabilizerGloves.r1,
    result.fields.stabilizerGlovesType.r1,
    result.fields.secondaryGlovesRemoval.r1,
    ...result.fields.handHygieneAfterR1StabilizerGloves.r1,
    result.fields.dressingSet.r1,
    result.fields.repairGloves.r1,
    result.fields.repairGlovesType.r1,
    result.fields.insertionSiteCleaned.p1p2p3p4r1,
    result.fields.auditedCleanSkin.p1,
    ...result.fields.handHygieneBeforeP1SkinCleaning.p1,
    result.fields.skinGloves.p1,
    result.fields.skinGlovesType.p1,
    result.fields.secondaryGlovesRemoval.p1,
    result.fields.soap.r1,
    result.fields.rinsing.r1,
    result.fields.dryingWithSterileCompresses.r1,
    ...result.fields.antiseptic.r1,
    ...result.fields.antiseptic.p1p2p3p4,
    result.fields.auditedApplyASQ.p1,
    ...result.fields.handHygieneBeforeP1Antiseptic.p1,
    result.fields.antisepticGloves.p1,
    result.fields.antisepticGlovesType.p1,
    result.fields.thirdGlovesRemoval.p1,
    result.fields.useCompresses.r1,
    result.fields.useCompresses.p1p2p3p4,
    result.fields.useCompresses.b1b2,
    result.fields.compressesType.r1,
    result.fields.compressesType.p1p2p3p4,
    result.fields.compressesType.b1b2,

    ...result.fields.antiseptic.b1,
    ...result.fields.antiseptic.b2,

    result.fields.dry.r1,
    result.fields.thirdGlovesRemoval.r1,
    ...result.fields.handHygieneAfterR1RepairGloves.r1,
    ...result.fields.handHygieneBeforeB2Manip.b2,
    result.fields.implementationGloves.r1,
    result.fields.implementationGlovesType.r1,
    result.fields.newStabilizer.r1,
    result.fields.antiPeelingProduct.r1,
    result.fields.newDressingWithCompresses.r1,
    result.fields.newDressingSterileSemiPermeableTransparent.r1,
    result.fields.newDressingImpregnated.r1,
    result.fields.fourthGlovesRemoval.r1,
    ...result.fields.handHygieneAfterR1ImplementationGloves.r1,
    result.fields.gloves.b2,
    result.fields.glovesType.b2,
    result.fields.glovesPutOnManip.b2,
    result.fields.valve.b1b2,
    ...result.fields.valveAntiseptic.b1b2,
    result.fields.antisepticPassages.p1p2p3p4,
    result.fields.dry.p1p2p3p4,

    ...result.fields.handHygieneBeforeInsertion.p1,
    ...result.fields.handHygieneBeforePeriInsertion.p2p4,
    ...result.fields.handHygieneBeforePuncture.p3,

    result.fields.glovesNecessary.b1,
    result.fields.gloves.p2p3p4b1,
    result.fields.glovesType.p2p3p4b1,
    result.fields.insertionGloves.p1,
    result.fields.insertionGlovesType.p1,

    result.fields.insertionUltrasoundSheath.p1,
    result.fields.probeCovered.p1,
    result.fields.sheathJustBeforeInsertion.p1,
    result.fields.insertionGelUsed.p1,
    result.fields.gelApplied.p1,
    result.fields.probeNeedleContact.p1,
    result.fields.auditedTouchProbe.p1,
    result.fields.probeTouchedWith.p1,
    result.fields.probeTouchedWithDetail.p1,
    result.fields.fourthGlovesRemoval.p1,
    result.fields.glovesPutOn.p2p3p4,
    result.fields.holdTissue.p4,
    result.fields.palpation.p2,
    result.fields.preFencedSterileField.p3,
    result.fields.chpSwabbing.p3b2,
    result.fields.chpSwabNumber.p3b2,
    result.fields.nakedEyeSheathInspection.p1,
    result.fields.probeInspection.p1,
    result.fields.tearedSheath.p1,
    result.fields.dirtyProbe.p1,
    result.fields.probeCleaned.p1,
    result.fields.probeCleaningMethod.p1,
    result.fields.probeCleaningMethodDetail.p1,
    ...result.fields.probeCleaningProduct.p1,

    ...result.fields.whyNCAuditedOutfit.p1p3,
    ...result.fields.whyNotAuditedMask.b2,
    ...result.fields.whyNCPatientOutfit.p3b2,
    ...result.fields.whyNotHHAfterDressingRemoval.r1,
    ...result.fields.whyNotGROnStabilizerChange.r1,
    ...result.fields.whyNotHHAfterStabilizerGR.r1,
    ...result.fields.whyNotSGForAntisepsis.r1,
    ...result.fields.whySheathNotRemovedAfterSearch.p1,
    ...result.fields.whyNotAlcool.p1p2p3p4,
    ...result.fields.whyNotAlcool.r1,
    ...result.fields.whyNotHHC.p1,
    ...result.fields.whyNotHH.p2p4,
    ...result.fields.whyNotHHP.p3,
    ...result.fields.whyNotHHCompliant.p2,
    ...result.fields.whyNotGloves.p2p4,
    ...result.fields.whyNotHHM.b1,
    ...result.fields.whyNotHHM.b2,
    ...result.fields.whyNotSterileGloves.b2,
    ...result.fields.whyNotCompresses.b1,
    ...result.fields.whyNotSterileCompresses.b1,
    ...result.fields.whyNotDisinfectValve.b1b2,
    ...result.fields.whyNotRemoveGlovesAfterTouch.p1
  ],

  buildNotes: function (resultNotes, sheet) {
    checkAge(
      resultNotes, sheet, {
        unitType: patient.unitType.v1.rw.field,
        isAdult: result.fields.isAdult.p1p2p3r1.field,
        childAge: result.fields.childAge.p1p2p3r1.field
      }
    )
    checkDate(
      resultNotes, sheet, '2023', {
        obsDate: result.fields.obsDate.all,
        insertionDate: result.fields.insertionDate.r1.field,
        lastDressingDate: result.fields.lastDressingDate.r1.field
      }
    )
    checkCompresses(
      resultNotes, sheet, {
        antiseptic: result.fields.antiseptic.p1p2p3p4[1].field,
        useCompresses: result.fields.useCompresses.p1p2p3p4.field
      }
    )
    checkGlovesPutOn(
      resultNotes, sheet, {
        gloves: result.fields.gloves.p2p3p4b1.field,
        glovesPutOn: result.fields.glovesPutOn.p2p3p4.field,
        handHygieneBeforePeriInsertion: result.fields.handHygieneBeforePeriInsertion.p2p4[0].field,
        whyNotHH: result.fields.whyNotHH.p2p4[0].field
      }
    )

    checkB2Gloves(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        whyNotHHM: result.fields.whyNotHHM.b2[0].field,
        gloves: result.fields.gloves.b2.field,
        glovesPutOnManip: result.fields.glovesPutOnManip.b2.field,
        handHygieneBeforeB2Manip: result.fields.handHygieneBeforeB2Manip.b2[0].field
      }
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.p1.field,
        insertionSite: result.fields.insertionSite.p1.field
      },
      'p1'
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 7, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.r1.field,
        insertionSite: result.fields.insertionSite.r1.field
      },
      'r1'
    )

    checkR1(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        whyNotSGForAntisepsis: result.fields.whyNotSGForAntisepsis.r1[0].field,
        dressingSet: result.fields.dressingSet.r1.field,
        changeStabilizer: result.fields.changeStabilizer.r1.field,
        newStabilizer: result.fields.newStabilizer.r1.field,
        hasStabilizer: result.fields.hasStabilizer.r1.field
      }
    )

    checkProbeTouchedWithGloves(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        probeTouchedWith: result.fields.probeTouchedWith.p1.field
      },
      result.fields.fourthGlovesRemoval.p1
    )

    checkBMI(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field
      }
    )

    return resultNotes
  }
}

result.assertAllFieldsAreUsed('2023')
export default ice.freeze(result, 10)
